// extracted by mini-css-extract-plugin
export var button = "_cn-7";
export var buttonRow = "_cn-6";
export var fadeIn = "_cn-1";
export var gradient = "_cn-0";
export var panel = "_cn-2";
export var panelIn = "_cn-3";
export var subtitle = "_cn-5";
export var title = "_cn-4";